export enum BadgeType {
  CircularText,
  SemiSquareText,
  Icon,
  Image,
}

export interface IBwjListingBadgeProps {
  type: BadgeType;
  content: string;
  color?: string;
  alt?: string;
}

export interface IActionItemProps {
  icon?: string;
  color?: string;
  text?: string;
  onClick?: (data: any) => void;
}